(function () {
  if (window.__odditProductRecsLoaded) return;
  window.__odditProductRecsLoaded = true;

  var SELECTOR = '[data-recommendations-intent]';

  function loadRecommendations(el) {
    var sectionEl = el.closest('[id^="shopify-section-"]');
    if (!sectionEl) return;

    var sectionId = sectionEl.id.replace('shopify-section-', '');
    var productId = el.getAttribute('data-product-id');
    var intent = el.getAttribute('data-recommendations-intent') || 'related';
    var limit = el.getAttribute('data-recommendations-limit') || 4;

    if (!productId) return;

    var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&intent=' + encodeURIComponent(intent) +
      '&limit=' + encodeURIComponent(limit);

    fetch(url)
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var match = doc.querySelector(
          '[data-recommendations-intent="' + intent + '"]'
        );
        if (match && match.innerHTML.trim()) {
          el.innerHTML = match.innerHTML;
          el.querySelectorAll('.oddit-reveal').forEach(function (node) {
            node.classList.add('is-visible');
          });

          if (el.hasAttribute('data-recommendations-hide-empty')) {
            var grid = el.querySelector('[data-complementary-products]');
            var hasProducts = grid ? grid.children.length > 0 : el.children.length > 0;
            el.style.display = hasProducts ? '' : 'none';
          }

          // Notify any section-level handlers that the recommendations block
          // was just replaced so they can rebind any listeners (carousel
          // progress, etc.) that were attached to the now-removed nodes.
          el.dispatchEvent(new CustomEvent('oddit:recommendations:loaded', { bubbles: true }));
        }
      })
      .catch(function () { /* silent */ });
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(loadRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
